import { gsap } from 'gsap';
export class PageHeader {
    el;
    header;
    subNavigation;
    media;
    breadcrumb;
    content;
    embellishment;
    logo;
    footer;
    title;
    subtitle;
    icon;
    constructor(el) {
        this.el = el;
        this.header = document.getElementById('masthead');
        this.subNavigation = document.getElementById('site-secondary-navigation-wrapper');
        this.media = el?.querySelector('video') ? el?.querySelector('video') : el?.querySelector('img');
        this.breadcrumb = el?.querySelector('.breadcrumb');
        this.content = el?.querySelector('.the-content');
        this.embellishment = el?.querySelector('.embellishment');
        this.logo = el?.querySelector('.event-logo');
        this.footer = el?.querySelector('footer');
        this.title = el?.querySelector('h1');
        this.subtitle = el?.querySelector('h2');
        this.icon = el?.querySelector('.icon');
        this.init();
    }
    init() {
        const tl = gsap.timeline();
        tl.add('start');
        if (this.media) {
            tl.fromTo(this.media, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, duration: 0.25
            })
                .fromTo(this.media, {
                scaleX: 1.2,
                scaleY: 1.2,
                transformOrigin: '50% 50%',
            }, {
                scaleX: 1,
                scaleY: 1,
                transformOrigin: '50% 50%',
                duration: 0.5
            });
        }
        tl.add('middle');
        if (this.title) {
            const elements = this.title.querySelectorAll('span');
            tl.fromTo(elements, {
                autoAlpha: 0,
                transform: 'translate3d(0, 100%, 0)'
            }, {
                duration: 0.75,
                transform: 'none',
                autoAlpha: 1,
                stagger: {
                    each: 0.06,
                    from: 'start'
                }
            }, 'middle');
        }
        if (this.subtitle) {
            tl.fromTo(this.subtitle, {
                autoAlpha: 0,
                y: 8,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.icon) {
            tl.fromTo(this.icon, {
                autoAlpha: 0,
                y: 8,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.breadcrumb) {
            tl.fromTo(this.breadcrumb, {
                autoAlpha: 0,
                y: 8,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.content) {
            tl.fromTo(this.content, {
                autoAlpha: 0,
                y: 16,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.logo) {
            tl.fromTo(this.logo, {
                autoAlpha: 0,
                y: 16,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.embellishment) {
            tl.fromTo(this.embellishment, {
                autoAlpha: 0,
                y: 16,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.footer) {
            tl.fromTo(this.footer, {
                autoAlpha: 0,
                y: 16,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'middle');
        }
        if (this.header) {
            tl.to(this.header, {
                y: 0,
                transformOrigin: '50% 50%',
                duration: 0.25,
                delay: 0.5
            }, 'middle');
        }
        if (this.subNavigation) {
            tl.to(this.subNavigation, {
                autoAlpha: 1,
                y: 0,
                transformOrigin: '50% 50%',
                duration: 0.25,
                delay: 0.75
            }, 'middle');
        }
        tl.add('end');
        if (this.header) {
            tl.set(this.header, { clearProps: 'transform' }, 'end');
        }
        if (this.subNavigation) {
            tl.set(this.subNavigation, { clearProps: 'transform' }, 'end');
        }
    }
}
